module.exports = __webpack_public_path__ + "static/media/Order_confirmation.97c3eb63.jpg";